import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc8c440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mission-statement" }, [
  /*#__PURE__*/_createElementVNode("p", null, " BackGround Gaming Media exists to create a welcoming, always-on space where games are preserved, shared, and celebrated. Through 24/7 streams, community-driven content, and collaborative projects, we build living databases of gaming history while supporting creators, fostering inclusion, and using our platform to do good. ")
], -1))
const _hoisted_3 = { class: "team-grid" }
const _hoisted_4 = { class: "team-grid" }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = { class: "team-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_TeamMemberCard = _resolveComponent("TeamMemberCard")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_divider, { class: "my-6" }),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        _ctx.onTabChange
      ],
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "leadership" }, {
          default: _withCtx(() => [
            _createTextVNode("Leadership")
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "bounty-hunters" }, {
          default: _withCtx(() => [
            _createTextVNode("Bounty Hunters")
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "tekken" }, {
          default: _withCtx(() => [
            _createTextVNode("TEKKEN FGC")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "leadership" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadership, (member) => {
                return (_openBlock(), _createBlock(_component_TeamMemberCard, {
                  key: member.name,
                  member: member
                }, null, 8, ["member"]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "tekken" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tekkenEsports, (member) => {
                return (_openBlock(), _createBlock(_component_TeamMemberCard, {
                  key: member.name,
                  member: member
                }, null, 8, ["member"]))
              }), 128)),
              (_ctx.tekkenEsports.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No Tekken esports members listed yet. "))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "bounty-hunters" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bountyHunters, (member) => {
                return (_openBlock(), _createBlock(_component_TeamMemberCard, {
                  key: member.name,
                  member: member
                }, null, 8, ["member"]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}